import { render, staticRenderFns } from "./DefaultTab.vue?vue&type=template&id=1fcc660e&scoped=true"
import script from "./DefaultTab.vue?vue&type=script&lang=js"
export * from "./DefaultTab.vue?vue&type=script&lang=js"
import style0 from "./DefaultTab.vue?vue&type=style&index=0&id=1fcc660e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcc660e",
  null
  
)

export default component.exports